export default __webpack_public_path__ + "locales/uk-UA/Errors.json?hash=a5fc17ead71b4e8a0f81477f55ad9d30";